  /**
   * Strips Unicode symbol/icon characters that most export fonts cannot render.
   * Covered blocks:
   *   U+2300–U+27BF  Misc Technical, Misc Symbols, Dingbats
   *   U+2B50–U+2B55  Stars / misc geometric
   *   U+FE0F          Variation Selector-16 (invisible emoji modifier)
   *   U+1F300–U+1F9FF All main emoji blocks
   *   U+1FA00–U+1FAFF Chess & newer emoji
   */
  export function stripUnicodeIcons(text: string): string {
    return text.replace(
      /[\u2300-\u27BF\u2B50-\u2B55\uFE0F]|[\u{1F300}-\u{1F9FF}]|[\u{1FA00}-\u{1FAFF}]/gu,
      ''
    );
  }
